import type { Props } from './Svg'
import { Svg } from './Svg'

export function Water2Icon(props: Props) {
  return (
    <Svg width="46" height="42" {...props}>
      <path
        fill="currentColor"
        d="M32.9 13.6c-4 0-7.9-1.6-11.5-4.8-5.3-4.7-11.2-4.7-16.5 0-1 .9-2.6.8-3.5-.2-.9-1-.8-2.6.2-3.5 7.2-6.4 15.9-6.4 23.1 0 5.3 4.7 11.2 4.7 16.5 0 1-.9 2.6-.8 3.5.2.9 1 .8 2.6-.2 3.5a17.4 17.4 0 0 1-11.6 4.8ZM32.9 27.6c-4 0-7.9-1.6-11.5-4.8-5.3-4.7-11.2-4.7-16.5 0-1 .9-2.6.8-3.5-.2-.9-1-.8-2.6.2-3.5 7.2-6.4 15.9-6.4 23.1 0 5.3 4.7 11.2 4.7 16.5 0 1-.9 2.6-.8 3.5.2.9 1 .8 2.6-.2 3.5a17 17 0 0 1-11.6 4.8ZM32.9 41.7c-4 0-7.9-1.6-11.5-4.8-5.3-4.7-11.2-4.7-16.5 0-1 .9-2.6.8-3.5-.2-.9-1-.8-2.6.2-3.5 7.2-6.4 15.9-6.4 23.1 0 5.3 4.7 11.2 4.7 16.5 0 1-.9 2.6-.8 3.5.2.9 1 .8 2.6-.2 3.5a17.4 17.4 0 0 1-11.6 4.8Z"
      />
    </Svg>
  )
}
